import {useState} from "../../../__snowpack__/pkg/react.js";
import {createModel} from "../../../__snowpack__/pkg/hox.js";
import {axios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
export const usePermissions = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const {data: data2} = await axios.post(`/saas/merchant/role-permissions`);
      setData(data2);
      return {
        permissions: data2
      };
    } catch (error) {
      handleError(error);
      return {
        permissions: data
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    permissionsLoading: loading,
    permissions: data,
    fetchPermissions: fetchData
  };
};
export const usePermissionsModel = createModel(usePermissions);
